"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/assets/ai_avatar.svg
var require_ai_avatar = __commonJS({
  "src/assets/ai_avatar.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M16 11.6667C19.2217 11.6667 21.8334 9.05499 21.8334 5.83333C21.8334 2.61167 19.2217 0 16 0C12.7784 0 10.1667 2.61167 10.1667 5.83333C10.1667 9.05499 12.7784 11.6667 16 11.6667Z" fill="url(%23paint0_linear_2177_7002)"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1667 15.8333C13.3883 15.8333 16 13.2217 16 10C16 6.77834 13.3883 4.16667 10.1667 4.16667C6.94503 4.16667 4.33335 6.77834 4.33335 10C4.33335 13.2217 6.94503 15.8333 10.1667 15.8333ZM10.1667 20C15.6895 20 20.1667 15.5228 20.1667 10C20.1667 4.47715 15.6895 0 10.1667 0C4.64384 0 0.166687 4.47715 0.166687 10C0.166687 15.5228 4.64384 20 10.1667 20Z" fill="%232C89EB"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8643 10.7529C12.931 10.5133 12.9667 10.2608 12.9667 9.99992C12.9667 8.50792 11.7997 7.28849 10.3288 7.20453C10.2228 6.76475 10.1667 6.30555 10.1667 5.83325C10.1667 3.50989 11.525 1.50378 13.4908 0.565674C17.3546 1.92705 20.1309 5.59491 20.1663 9.91608C19.1076 10.9963 17.6321 11.6666 16 11.6666C14.8458 11.6666 13.7699 11.3314 12.8643 10.7529Z" fill="url(%23paint1_linear_2177_7002)"/>%0A<path d="M16 11.6667C19.2217 11.6667 21.8334 9.05499 21.8334 5.83333C21.8334 2.61167 19.2217 0 16 0C12.7784 0 10.1667 2.61167 10.1667 5.83333C10.1667 9.05499 12.7784 11.6667 16 11.6667Z" fill="url(%23paint2_linear_2177_7002)"/>%0A<defs>%0A<linearGradient id="paint0_linear_2177_7002" x1="11.9451" y1="1.7784" x2="20.3142" y2="9.71533" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A<linearGradient id="paint1_linear_2177_7002" x1="14.5106" y1="4.67558" x2="17.6259" y2="11.1848" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%2374BF4B" stop-opacity="0"/>%0A<stop offset="1" stop-color="%2374BF4B"/>%0A</linearGradient>%0A<linearGradient id="paint2_linear_2177_7002" x1="11.9451" y1="1.7784" x2="20.3142" y2="9.71533" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/assets/ai_logo_large.svg
var require_ai_logo_large = __commonJS({
  "src/assets/ai_logo_large.svg"(exports, module2) {
    module2.exports = "data:image/svg+xml,<svg%0A  xmlns='http://www.w3.org/2000/svg'%0A  width='174'%0A  height='160'%0A  viewBox='0 0 174 160'%0A  fill='none'%0A>%0A  <path%0A    d='M126.796 93.3095C152.563 93.3095 173.451 72.4214 173.451 46.6547C173.451 20.888 152.563 0 126.796 0C101.03 0 80.1416 20.888 80.1416 46.6547C80.1416 72.4214 101.03 93.3095 126.796 93.3095Z'%0A    fill='url(%23paint0_linear_7913_1973)'%0A  />%0A  <path%0A    fill-rule='evenodd'%0A    clip-rule='evenodd'%0A    d='M80 126.667C105.773 126.667 126.667 105.773 126.667 80C126.667 54.2267 105.773 33.3333 80 33.3333C54.2267 33.3333 33.3333 54.2267 33.3333 80C33.3333 105.773 54.2267 126.667 80 126.667ZM80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z'%0A    fill='%230E2B56'%0A  />%0A  <path%0A    fill-rule='evenodd'%0A    clip-rule='evenodd'%0A    d='M124.72 93.273C125.971 89.0633 126.642 84.605 126.642 79.9901C126.642 54.8821 106.763 34.4094 81.8604 33.4029C85.6433 20.6727 94.7242 10.2168 106.552 4.58191C137.488 15.4635 159.716 44.7808 160 79.32C151.523 87.9545 139.709 93.3118 126.642 93.3118C125.998 93.3118 125.357 93.2988 124.72 93.273Z'%0A    fill='url(%23paint1_linear_7913_1973)'%0A  />%0A  <path%0A    d='M126.796 93.3095C152.563 93.3095 173.451 72.4214 173.451 46.6547C173.451 20.888 152.563 0 126.796 0C101.03 0 80.1416 20.888 80.1416 46.6547C80.1416 72.4214 101.03 93.3095 126.796 93.3095Z'%0A    fill='url(%23paint2_radial_7913_1973)'%0A  />%0A  <defs>%0A    <linearGradient%0A      id='paint0_linear_7913_1973'%0A      x1='94.3652'%0A      y1='14.2236'%0A      x2='161.301'%0A      y2='77.7028'%0A      gradientUnits='userSpaceOnUse'%0A    >%0A      <stop stop-color='%233B76EA' />%0A      <stop offset='0.515625' stop-color='%2300BCEB' />%0A      <stop offset='1' stop-color='%2363FFF7' />%0A    </linearGradient>%0A    <linearGradient%0A      id='paint1_linear_7913_1973'%0A      x1='115.805'%0A      y1='37.4325'%0A      x2='141.057'%0A      y2='89.0163'%0A      gradientUnits='userSpaceOnUse'%0A    >%0A      <stop stop-color='%2374BF4B' stop-opacity='0' />%0A      <stop offset='1' stop-color='%2374BF4B' />%0A    </linearGradient>%0A    <radialGradient%0A      id='paint2_radial_7913_1973'%0A      cx='0'%0A      cy='0'%0A      r='1'%0A      gradientUnits='userSpaceOnUse'%0A      gradientTransform='translate(156.315 72.709) rotate(90) scale(99.1762 99.1343)'%0A    >%0A      <stop offset='0.661663' stop-color='%2300BCEB' stop-opacity='0' />%0A      <stop offset='1' stop-color='%2300BCEB' />%0A    </radialGradient>%0A  </defs>%0A</svg>";
  }
});

// src/assets/empty_state.svg
var require_empty_state = __commonJS({
  "src/assets/empty_state.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">%0A  <rect opacity="0.4" x="67.8572" y="11.6206" width="9.16071" height="40.7143" rx="4.58036" transform="rotate(25 67.8572 11.6206)" fill="%23FFC7C9"/>%0A  <rect opacity="0.2" x="12.5657" y="31.2144" width="9.16072" height="30.5357" rx="4.58036" transform="rotate(25 12.5657 31.2144)" fill="%23FFC7C9"/>%0A  <rect opacity="0.3" x="23.1105" y="-0.339355" width="9.16071" height="16.3504" rx="4.58036" transform="rotate(25 23.1105 -0.339355)" fill="%23FFC7C9"/>%0A  <path d="M35.222 17.0154C36.9387 16.0141 39.0614 16.0141 40.7781 17.0154L55.1129 25.3774C56.8067 26.3655 57.8483 28.1788 57.8483 30.1398V45.8599C57.8483 47.8208 56.8067 49.6342 55.1129 50.6222L40.7781 58.9842C39.0614 59.9856 36.9387 59.9856 35.222 58.9842L20.8872 50.6222C19.1934 49.6342 18.1519 47.8208 18.1519 45.8599V30.1398C18.1519 28.1788 19.1934 26.3655 20.8872 25.3774L35.222 17.0154Z" fill="%23CC2D37"/>%0A  <path fill-rule="evenodd" clip-rule="evenodd" d="M35.7947 39.1025L35.7947 29.7298C35.7947 28.5118 36.7821 27.5244 38.0001 27.5244C39.2181 27.5244 40.2055 28.5118 40.2055 29.7298L40.2055 39.1025C40.2055 40.3205 39.2181 41.3079 38.0001 41.3079C36.7821 41.3079 35.7947 40.3205 35.7947 39.1025Z" fill="white"/>%0A  <path d="M40.7568 46.8213C40.7568 48.3438 39.5226 49.578 38.0001 49.578C36.4776 49.578 35.2434 48.3438 35.2434 46.8213C35.2434 45.2988 36.4776 44.0646 38.0001 44.0646C39.5226 44.0646 40.7568 45.2988 40.7568 46.8213Z" fill="white"/>%0A</svg>%0A';
  }
});

// src/assets/airplane.svg
var require_airplane = __commonJS({
  "src/assets/airplane.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M18.944 9.6876L3.1471 0.846974C2.88389 0.693483 2.5808 0.622181 2.27677 0.642228C1.97273 0.662274 1.68163 0.772752 1.44085 0.959474C1.19495 1.15349 1.01641 1.42003 0.930587 1.72127C0.84476 2.0225 0.856006 2.34312 0.962727 2.6376L3.5971 9.99697C3.62375 10.0704 3.67211 10.1339 3.73575 10.1791C3.79939 10.2243 3.87529 10.2491 3.95335 10.2501H10.7221C10.9167 10.247 11.1053 10.3179 11.2497 10.4484C11.3941 10.5789 11.4836 10.7593 11.5002 10.9532C11.5066 11.0556 11.492 11.1582 11.4572 11.2547C11.4224 11.3511 11.3681 11.4394 11.2978 11.5141C11.2276 11.5888 11.1427 11.6483 11.0485 11.6889C10.9543 11.7295 10.8528 11.7503 10.7502 11.7501H3.95335C3.87529 11.7511 3.79939 11.7759 3.73575 11.8211C3.67211 11.8663 3.62375 11.9298 3.5971 12.0032L0.962727 19.3626C0.883682 19.5893 0.859864 19.8316 0.893251 20.0694C0.926638 20.3072 1.01627 20.5335 1.15469 20.7297C1.29312 20.9259 1.47635 21.0862 1.68917 21.1974C1.90199 21.3085 2.13826 21.3673 2.37835 21.3689C2.63385 21.3677 2.88508 21.3033 3.1096 21.1814L18.944 12.3126C19.176 12.1809 19.3689 11.99 19.5031 11.7594C19.6373 11.5289 19.708 11.2669 19.708 11.0001C19.708 10.7333 19.6373 10.4713 19.5031 10.2408C19.3689 10.0102 19.176 9.81934 18.944 9.6876Z" fill="url(%23paint0_linear_1961_3983)"/>%0A<defs>%0A<linearGradient id="paint0_linear_1961_3983" x1="17.5779" y1="27.4659" x2="37.8035" y2="-8.91342" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AIAssistant: () => AIAssistant,
  AIChatWindow: () => AIChatWindow
});
module.exports = __toCommonJS(src_exports);

// src/components/aiAssistant/AIAssistant.tsx
var import_react7 = require("react");
var import_uik15 = require("@appd/uik");

// src/components/aiAssistant/STYLES.ts
var import_uik = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_WEAK, DEFAULT_TEXT_MEDIUM },
  SPACING,
  RADIUS,
  TYPOGRAPHY: { P3_DEFAULT, P4_DEFAULT, WEIGHT_EMPHASIS }
} = import_uik.MAGNETIC_TOKENS;
var STYLES = {
  CONTAINER: (0, import_uik.css)({
    backgroundColor: CONTROL_BG_WEAK,
    height: "100%",
    display: "flex",
    flexDirection: "column"
  }),
  CONVERSATION: (0, import_uik.css)({
    padding: SPACING[5],
    overflowY: "auto"
  }),
  CONVERSATION_CONTAINER: (0, import_uik.css)({
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "flex-end",
    overflowY: "hidden"
  }),
  MACRO_CONTAINER: (0, import_uik.css)({
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: SPACING[5],
    paddingRight: SPACING[5]
  }),
  MACRO_CONTENT: (0, import_uik.css)({
    /**
     * Needed to display ellipsis on multiline text on the macro
     * Browser coverage is fairly good across Chrome, Edge, Safari, Firefox
     *
     * See:
     * https://caniuse.com/?search=line-clamp
     * https://caniuse.com/?search=box-orient
     */
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    color: DEFAULT_TEXT_MEDIUM,
    font: P3_DEFAULT
  }),
  MODEL_ONE_DROPDOWN: (0, import_uik.css)({
    flex: 1,
    overflow: "visible",
    marginBottom: "8px"
  }),
  INPUT_CONTAINER: (0, import_uik.css)({
    paddingLeft: SPACING[5],
    paddingRight: SPACING[5],
    paddingBottom: SPACING[1],
    paddingTop: SPACING[4],
    display: "flex",
    gap: SPACING[3],
    alignItems: "center"
  }),
  INPUT: (0, import_uik.css)({
    flex: 1,
    maxWidth: "100%"
  }),
  FOOTER: (0, import_uik.css)({
    textAlign: "center",
    font: P4_DEFAULT,
    color: DEFAULT_TEXT_MEDIUM,
    paddingLeft: SPACING[5],
    paddingRight: SPACING[5],
    paddingBottom: SPACING[1]
  }),
  ANSWER: (0, import_uik.css)({
    flex: "1 1 auto",
    maxWidth: "100%",
    marginTop: SPACING[2],
    marginBottom: SPACING[2],
    marginRight: SPACING[6]
  }),
  QUESTION_HEADING: (0, import_uik.css)({
    display: "flex",
    alignItems: "center",
    padding: SPACING[4],
    marginTop: SPACING[2],
    marginBottom: SPACING[2]
  }),
  QUESTION: (0, import_uik.css)({
    padding: SPACING[4],
    marginTop: SPACING[2],
    marginBottom: SPACING[2]
  }),
  AVATAR: (0, import_uik.css)({
    marginBottom: SPACING[2],
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: SPACING[2],
    fontWeight: WEIGHT_EMPHASIS
  }),
  AVATAR_ICON: (0, import_uik.css)({
    borderRadius: RADIUS.FULL,
    height: "24px",
    width: "24px",
    backgroundColor: "#ACACAC"
  })
};

// src/components/aiResponse/AIResponse.tsx
var import_uik9 = require("@appd/uik");
var import_react4 = require("react");

// src/components/aiResponse/STYLES.ts
var import_uik2 = require("@appd/uik");
var {
  COLORS: { BRAND_ACCENT_BORDER_WEAK, CONTROL_BG_DISABLED, CONTROL_BG_STRONG },
  SPACING: SPACING2,
  TYPOGRAPHY: { WEIGHT_EMPHASIS: WEIGHT_EMPHASIS2 }
} = import_uik2.MAGNETIC_TOKENS;
var STYLES2 = {
  CONTAINER: (0, import_uik2.css)({
    paddingTop: SPACING2[5],
    paddingRight: SPACING2[5],
    paddingBottom: SPACING2[4],
    paddingLeft: SPACING2[6],
    transition: "all 0.75s ease",
    background: `linear-gradient(${CONTROL_BG_DISABLED}, ${CONTROL_BG_DISABLED}) padding-box, 
    linear-gradient(4deg, #3b76ea 10.22%, #00bceb 88.93%, #63fff7 162.86%) border-box`,
    borderRadius: "4px",
    borderLeft: "4px solid transparent",
    "& p:first-of-type": {
      marginTop: "0",
      marginBottom: "0"
    }
  }),
  RESPONSE_BOTTOM_CONTAINER: (0, import_uik2.css)({
    borderTop: `2px solid ${BRAND_ACCENT_BORDER_WEAK}`,
    paddingTop: SPACING2[4],
    marginTop: SPACING2[4],
    transition: "all  0.75s ease"
  }),
  TIMEOUT_BUTTON_CONTAINER: (0, import_uik2.css)({
    display: "flex",
    gap: SPACING2[3]
  }),
  RESPONSE_TEXT: (0, import_uik2.css)({
    lineHeight: "22px",
    "& code": {
      whiteSpace: "pre-wrap"
    },
    "& a": {
      color: CONTROL_BG_STRONG,
      textDecoration: "none",
      fontWeight: WEIGHT_EMPHASIS2,
      display: "block",
      whiteSpace: "nowrap",
      width: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "& p": {
      whiteSpace: "pre-line"
    },
    "& ol": {
      listStyle: "revert"
      // cSaaS is overwritting a lot of styles
    }
  }),
  SPINNER: (0, import_uik2.css)({
    "& div:first-child > div": {
      border: "4px solid #3b9eea",
      borderColor: "#3b9eea transparent transparent transparent"
    },
    "& div:nth-child(2)": {
      fontWeight: WEIGHT_EMPHASIS2,
      background: "-webkit-linear-gradient(#00bceb, #3b76ea)",
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent"
    }
  }),
  RECOMMENDATIONS_TITLE: (0, import_uik2.css)({
    fontWeight: WEIGHT_EMPHASIS2,
    paddingBottom: SPACING2[3]
  }),
  RECOMMENDATIONS: (0, import_uik2.css)({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: SPACING2[3],
    alignItems: "flex-start",
    "& > button": {
      maxWidth: "100%"
    }
  }),
  RECOMMENDATIONS_BUTTON: (0, import_uik2.css)({
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "block",
    textOverflow: "ellipsis"
  }),
  AVATAR: (0, import_uik2.css)({
    marginBottom: SPACING2[2],
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: SPACING2[2],
    fontWeight: WEIGHT_EMPHASIS2
  }),
  ANALYZE_REC: (0, import_uik2.css)({
    display: "flex",
    gap: SPACING2[3],
    flexWrap: "wrap",
    marginTop: SPACING2[2],
    marginBottom: SPACING2[2]
  }),
  ANALYZE_TEXT_START: (0, import_uik2.css)({
    fontWeight: WEIGHT_EMPHASIS2
  }),
  ANALYZE_CONTAINER: (0, import_uik2.css)({
    marginTop: SPACING2[3]
  })
};

// src/hooks/useFetchAIResponse.ts
var import_react = require("react");

// src/constants/CONSTANTS.ts
var API_BASE = "/session/api/ext/rest";
var AI_PATH = "/kanzi/rafiki";
var AI_PATH_MODAL = "/kanzi/solovar";
var CCO_DEFAULT_MODEL = "cco_html_v1";
var CSAAS_DEFAULT_MODEL = "csaas_html_v1";
var CONSTANTS = {
  IDENTITY_URL_LOCAL: "https://identity-api.saas.appd-test.com/v3.0/accounts/sessions/me",
  IDENTITY_URL_PROD: "https://identity-api.appdynamics.com/v3.0/accounts/sessions/me",
  SUPPORT_URL: "https://help.appdynamics.com/hc/en-us/requests",
  AI_RESPONSE: `${API_BASE}${AI_PATH}/rag`,
  AI_HEALTH: `${API_BASE}${AI_PATH}/health`,
  AI_CONVERSATIONS: `${API_BASE}${AI_PATH}/retrieve_conversation`,
  AI_RECOMMENDATIONS: `${API_BASE}${AI_PATH}/get_recommendations`,
  AI_CUSTOMER_FEEDBACK: `${API_BASE}${AI_PATH}/customer_feedback`,
  AI_INTERNAL_FEEDBACK: `${API_BASE}${AI_PATH}/internal_feedback`,
  AI_LOG_CONVERSATION: `${API_BASE}${AI_PATH}/log_conversation`,
  AI_TRAINING_MODELS: `${API_BASE}${AI_PATH}/models`
};

// src/constants/getAIUrl.ts
var getAIUrl = /* @__PURE__ */ __name((type, isCSaas, isHelpCenter, cSaasPrefix, helpCenterEndpoint, modalEndpoint, apiBasePath, isStream) => {
  const endpoint = isHelpCenter ? helpCenterEndpoint : modalEndpoint;
  const solutionPath = isHelpCenter ? AI_PATH : AI_PATH_MODAL;
  if (isCSaas && apiBasePath) {
    return `${apiBasePath}${solutionPath}${endpoint}`;
  }
  if (isCSaas && cSaasPrefix) {
    let restType = type === "GET" ? "/getData/fso" : "/postData/fso";
    if (isStream) {
      restType = type === "GET" ? "/getStreamData/fso" : "/postStreamData/fso";
    }
    const encodedEndpoint = encodeURIComponent(`/rest${solutionPath}${endpoint}`);
    return `${cSaasPrefix}${restType}?path=${encodedEndpoint}`;
  }
  return `${API_BASE}${solutionPath}${endpoint}`;
}, "getAIUrl");

// src/constants/getDefaultModel.ts
var getDefaultModel = /* @__PURE__ */ __name((isCSaas) => isCSaas ? CSAAS_DEFAULT_MODEL : CCO_DEFAULT_MODEL, "getDefaultModel");

// src/utils/fetchAIConversations.ts
var fetchAIConversations = /* @__PURE__ */ __name(async (isCSaas, cSaasPrefix, email, apiBasePath) => {
  const encodedEmailParam = isCSaas && !apiBasePath && cSaasPrefix ? encodeURIComponent(`?email=${email}`) : `?email=${email};`;
  const finalUrl = `${getAIUrl(
    "GET",
    isCSaas,
    false,
    cSaasPrefix,
    "",
    "/retrieve_conversation",
    apiBasePath,
    false
  )}${encodedEmailParam}`;
  const response = await fetch(finalUrl, {
    method: "get",
    headers: {
      Accept: "application/json, text/plain, */*"
    }
  });
  return response.json();
}, "fetchAIConversations");

// src/utils/fetchAIHealth.ts
var fetchAIHealth = /* @__PURE__ */ __name(async (isCSaas, isHelpCenter, cSaasPrefix, apiBasePath) => {
  const url = getAIUrl("GET", isCSaas, isHelpCenter, cSaasPrefix, "/health", "/health", apiBasePath, false);
  const response = await fetch(url, {
    method: "get",
    headers: {
      Accept: "application/json, text/plain, */*"
    }
  });
  if (response && (!response.ok || !response.body)) {
    return Promise.resolve({ status: "Unknown" });
  }
  return response.json();
}, "fetchAIHealth");

// src/utils/fetchAIResponse.ts
var fetchAPIResponse = /* @__PURE__ */ __name(async (requestBody, isCSaas, isHelpCenter, cSaasPrefix, apiBasePath, signal, onData, onFetching, onReading, onDone, onStreamInit, onError) => {
  try {
    const { query, conversationId, modelVersion, email, questionId, appName, appId } = requestBody;
    if (onFetching) {
      onFetching(true);
    }
    const url = getAIUrl("POST", isCSaas, isHelpCenter, cSaasPrefix, "/rag", "/ask_kanzi", apiBasePath, true);
    const helpCenterBody = {
      inputQuery: query,
      conversationId,
      model: modelVersion ?? getDefaultModel(isCSaas),
      useTextEventStream: true,
      email: email ?? "",
      questionId
    };
    const modalBody = {
      question: query,
      conversation_id: conversationId,
      email: email ?? "",
      question_id: questionId,
      app_name: appName ?? "",
      app_id: appId ?? "0"
    };
    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(isHelpCenter ? helpCenterBody : modalBody),
      signal
    });
    if (response && (!response.ok || !response.body)) {
      throw new Error(response.statusText);
    }
    const stream = response.body;
    if (!stream) {
      if (onError) {
        onError();
      }
      return;
    }
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    if (reader && onStreamInit) {
      onStreamInit(reader);
    }
    let done = false;
    let readStarted = false;
    let data = null;
    while (!done) {
      const { value, done: doneReading } = await reader.read();
      if (!readStarted && onFetching) {
        onFetching(false);
      }
      if (readStarted && onReading) {
        onReading(true);
      }
      readStarted = true;
      done = doneReading;
      if (!data) {
        data = "";
      }
      if (!doneReading) {
        const decodedChunks = decoder.decode(value, { stream: true }).split("\n");
        const result = decodedChunks.reduce(
          (accumulator, current) => {
            if (current !== "") {
              const decodedObject = JSON.parse(current);
              if (decodedObject.text !== void 0) {
                return {
                  ...accumulator,
                  text: `${accumulator.text}${decodedObject.text === "" ? " " : decodedObject.text}`
                };
              }
              if (decodedObject["chart:line"] !== void 0 && Array.isArray(decodedObject["chart:line"])) {
                accumulator.lineChart.push(...decodedObject["chart:line"]);
              }
              if (decodedObject["chart:table"] !== void 0) {
                accumulator.table = decodedObject["chart:table"];
              }
            }
            return accumulator;
          },
          { text: "", lineChart: [], table: void 0 }
        );
        if (result.text === "") {
          data += " ";
        } else {
          data += result.text;
        }
        onData({ text: data, lineChart: result.lineChart, table: result.table });
      }
    }
    if (onDone) {
      onDone();
    }
    if (onReading) {
      onReading(false);
    }
  } catch (error) {
    if (onError) {
      onError(error);
    }
    if (onFetching) {
      onFetching(false);
    }
    if (onReading) {
      onReading(false);
    }
    if (onDone) {
      onDone();
    }
    console.log("Error fetching response", error);
  }
}, "fetchAPIResponse");

// src/utils/fetchAIAnalyzeResponse.ts
var fetchAIAnalyzeResponse = /* @__PURE__ */ __name(async (requestBody, isCSaas, cSaasPrefix, apiBasePath, signal, onData, onFetching, onReading, onDone, onStreamInit, onError) => {
  try {
    const { conversationId, email, questionId, appName, appId } = requestBody;
    if (onFetching) {
      onFetching(true);
    }
    const url = getAIUrl("POST", isCSaas, false, cSaasPrefix, "/analyze", "/analyze", apiBasePath, true);
    const body = {
      question: "",
      // Question is blank for analyze
      conversation_id: conversationId,
      email: email ?? "",
      question_id: questionId,
      app_name: appName,
      app_id: appId
    };
    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body),
      signal
    });
    if (response && (!response.ok || !response.body)) {
      throw new Error(response.statusText);
    }
    const stream = response.body;
    if (!stream) {
      if (onError) {
        onError();
      }
      return;
    }
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    if (reader && onStreamInit) {
      onStreamInit(reader);
    }
    let done = false;
    let readStarted = false;
    let data = null;
    while (!done) {
      const { value, done: doneReading } = await reader.read();
      if (!readStarted && onFetching) {
        onFetching(false);
      }
      if (readStarted && onReading) {
        onReading(true);
      }
      readStarted = true;
      done = doneReading;
      if (!data) {
        data = "";
      }
      let analysisToken = null;
      if (!doneReading) {
        const decodedChunks = decoder.decode(value, { stream: true }).split("\n");
        const result = decodedChunks.reduce(
          (accumulator, current) => {
            if (current !== "") {
              const decodedObject = JSON.parse(current);
              if (decodedObject.text !== void 0) {
                return {
                  ...accumulator,
                  text: `${accumulator.text}${decodedObject.text === "" ? " " : decodedObject.text}`
                };
              }
              if (decodedObject.analysis !== void 0) {
                analysisToken = decodedObject.analysis;
              }
            }
            return accumulator;
          },
          { text: "" }
        );
        if (result.text === "") {
          data += " ";
        } else {
          data += result.text;
        }
        if (analysisToken) {
          onData({ text: data, analysis: analysisToken });
        } else {
          onData({ text: data, analysis: null });
        }
      }
    }
    if (onDone) {
      onDone();
    }
    if (onReading) {
      onReading(false);
    }
  } catch (error) {
    if (onError) {
      onError(error);
    }
    if (onFetching) {
      onFetching(false);
    }
    if (onReading) {
      onReading(false);
    }
    if (onDone) {
      onDone();
    }
    console.log("Error fetching analyze response", error);
  }
}, "fetchAIAnalyzeResponse");

// src/utils/fetchRecommendations.ts
var fetchRecommendations = /* @__PURE__ */ __name(async (count, questionId, isCSaas, isHelpCenter, cSaasPrefix, apiBasePath) => {
  const questionString = questionId ? `questionId=${questionId}&` : "";
  const endpoint = `/get_recommendations?${questionString}recommendation_count=${count}`;
  const url = getAIUrl("GET", isCSaas, isHelpCenter, cSaasPrefix, endpoint, endpoint, apiBasePath, false);
  const response = await fetch(url, {
    method: "get",
    headers: {
      Accept: "application/json, text/plain, */*"
    }
  });
  return response.json();
}, "fetchRecommendations");

// src/utils/generateUUID.ts
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
__name(generateUUID, "generateUUID");

// src/utils/renderMarkdown.ts
var import_marked = require("marked");
var import_html_react_parser = __toESM(require("html-react-parser"));
var import_dompurify = __toESM(require("dompurify"));
var escapeTest = /[&<>"']/;
var escapeReplace = new RegExp(escapeTest.source, "g");
var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
var escapeReplacements = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
var getEscapeReplacement = /* @__PURE__ */ __name((ch) => escapeReplacements[ch], "getEscapeReplacement");
var escape = /* @__PURE__ */ __name((html, encode) => {
  if (encode) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else if (escapeTestNoEncode.test(html)) {
    return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
  }
  return html;
}, "escape");
var markdownToHTMLString = /* @__PURE__ */ __name((value) => {
  import_marked.marked.use({
    renderer: {
      // Render links that open in new tab
      link(href = "#", title = "", content = "") {
        return `<a target="_blank" href=${href} title=${String(title)}>${content}</a>`;
      },
      // Copied from https://github.com/markedjs/marked/blob/master/src/Renderer.ts#L17
      // Only adding custom styles on the parent block
      code(code, infostring, escaped) {
        const lang = (infostring || "").match(/^\S*/)?.[0];
        const formattedCode = code.replace(/\n$/, "") + "\n";
        if (!lang) {
          return (
            // eslint-disable-next-line prefer-template
            '<pre style="overflow-x:auto;"><code>' + (escaped ? formattedCode : escape(formattedCode, true)) + "</code></pre>\n"
          );
        }
        return (
          // eslint-disable-next-line prefer-template
          '<pre style="overflow-x:auto;"><code class="language-' + escape(lang) + '">' + (escaped ? formattedCode : escape(formattedCode, true)) + "</code></pre>\n"
        );
      }
    },
    tokenizer: {
      /**
       *  Disable markdown setext headings since it causes headings to render
       *  when tokens are coming in
       *  Ex: '-' under some text but it's an bulleted list in progress
       */
      lheading() {
        return void 0;
      }
    }
  });
  return import_marked.marked.parse(value);
}, "markdownToHTMLString");
var renderMarkdown = /* @__PURE__ */ __name((value) => {
  const sanitizedString = import_dompurify.default.sanitize(markdownToHTMLString(value), { ADD_ATTR: ["target"] });
  return (0, import_html_react_parser.default)(sanitizedString);
}, "renderMarkdown");

// src/utils/submitFeedback.ts
var submitFeedback = /* @__PURE__ */ __name(async (positiveRating, question, additionalFeedback, answer, tags, conversationId, questionId, email, isCSaas, isHelpCenter, cSaasPrefix, apiBasePath) => {
  try {
    const url = getAIUrl(
      "POST",
      isCSaas,
      isHelpCenter,
      cSaasPrefix,
      "/customer_feedback",
      "/customer_feedback",
      apiBasePath,
      false
    );
    await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        question,
        answer,
        positiveRating,
        tags,
        additionalFeedback,
        email,
        model: getDefaultModel(isCSaas),
        conversationId,
        questionId
      })
    });
  } catch (error) {
    console.error(error);
  }
}, "submitFeedback");

// src/utils/sortConversations.ts
var sortConversations = /* @__PURE__ */ __name((history) => {
  const today = /* @__PURE__ */ new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const sevenDays = new Date(today);
  sevenDays.setDate(sevenDays.getDate() - 7);
  const thirtyDays = new Date(today);
  thirtyDays.setDate(thirtyDays.getDate() - 30);
  const conversationMap = /* @__PURE__ */ new Map();
  history.forEach((item) => {
    const itemDate = new Date(item.createdAt);
    const existingConversation = conversationMap.get(item.conversationId);
    if (!existingConversation || new Date(existingConversation.createdAt) < itemDate) {
      conversationMap.set(item.conversationId, item);
    }
  });
  const todayConversations = [];
  const yesterdayConversations = [];
  const pastSevenDaysConversations = [];
  const pastThirtyDaysConversations = [];
  const otherMonthsConversations = [];
  conversationMap.forEach((conversation, convoId) => {
    const updatedAtDate = new Date(conversation.updatedAt);
    switch (true) {
      case updatedAtDate >= today:
        todayConversations.push({ id: convoId, history: [conversation] });
        break;
      case updatedAtDate >= yesterday:
        yesterdayConversations.push({ id: convoId, history: [conversation] });
        break;
      case (updatedAtDate < yesterday && updatedAtDate >= sevenDays):
        pastSevenDaysConversations.push({ id: convoId, history: [conversation] });
        break;
      case (updatedAtDate >= thirtyDays && updatedAtDate < sevenDays):
        pastThirtyDaysConversations.push({ id: convoId, history: [conversation] });
        break;
      case updatedAtDate < thirtyDays:
        otherMonthsConversations.push({ id: convoId, history: [conversation] });
        break;
      default:
        break;
    }
  });
  const newHistoryItems = [
    { date: "Other Months", conversationIds: otherMonthsConversations },
    { date: "Previous 30 Days", conversationIds: pastThirtyDaysConversations },
    { date: "Previous 7 Days", conversationIds: pastSevenDaysConversations },
    { date: "Yesterday", conversationIds: yesterdayConversations },
    { date: "Today", conversationIds: todayConversations }
  ];
  return newHistoryItems;
}, "sortConversations");

// src/hooks/useFetchAIResponse.ts
var useFetchAIResponse = /* @__PURE__ */ __name((requestBody, signal, isCSaas, isHelpCenter, cSaasPrefix, apiBasePath) => {
  const { query, conversationId, modelVersion, email, questionId } = requestBody;
  const [data, setData] = (0, import_react.useState)({ text: "" });
  const [loading, setLoading] = (0, import_react.useState)(false);
  const [reading, setReading] = (0, import_react.useState)(false);
  const [error, setError] = (0, import_react.useState)(null);
  const [done, setDone] = (0, import_react.useState)(false);
  const [currentReader, setCurrentReader] = (0, import_react.useState)(null);
  (0, import_react.useEffect)(() => {
    setDone(false);
    const onData = /* @__PURE__ */ __name((updatedResponse) => {
      setData(updatedResponse);
    }, "onData");
    const onDone = /* @__PURE__ */ __name(() => {
      setDone(true);
    }, "onDone");
    const onStreamInit = /* @__PURE__ */ __name((reader) => {
      setCurrentReader(reader);
    }, "onStreamInit");
    const onError = /* @__PURE__ */ __name((err) => {
      if (err) {
        setError(err);
      }
      setDone(true);
    }, "onError");
    fetchAPIResponse(
      requestBody,
      isCSaas,
      isHelpCenter,
      cSaasPrefix,
      apiBasePath,
      signal,
      onData,
      setLoading,
      setReading,
      onDone,
      onStreamInit,
      onError
    ).catch((err) => setError(err));
  }, [query, conversationId, modelVersion, email, questionId, signal, isCSaas, isHelpCenter]);
  return { data, loading, reading, error, done, currentReader };
}, "useFetchAIResponse");

// src/components/feedbackForm/FeedbackForm.tsx
var import_react2 = require("react");
var import_uik4 = require("@appd/uik");

// src/components/feedbackForm/STYLES.ts
var import_uik3 = require("@appd/uik");
var {
  COLORS: { BRAND_ACCENT_BORDER_WEAK: BRAND_ACCENT_BORDER_WEAK2 },
  SPACING: SPACING3,
  TYPOGRAPHY: { HEADING_SMALLEST }
} = import_uik3.MAGNETIC_TOKENS;
var STYLES3 = {
  CONTAINER: (0, import_uik3.css)({
    display: "flex",
    flexDirection: "column"
  }),
  HEADER_CONTAINER: (0, import_uik3.css)({
    display: "flex",
    alignContent: "center",
    justifyContent: "space-between"
  }),
  HEADER_TEXT: (0, import_uik3.css)({
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center",
    font: HEADING_SMALLEST
  }),
  SELECTIONS: (0, import_uik3.css)({
    display: "flex",
    justifyContent: "flex-start",
    gap: SPACING3[6],
    paddingTop: SPACING3[2],
    paddingBottom: SPACING3[3]
  }),
  BUTTONS: (0, import_uik3.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: SPACING3[3],
    paddingTop: SPACING3[2]
  }),
  FEEDBACK_THUMBS_CONTAINER: (0, import_uik3.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: SPACING3[1],
    paddingTop: SPACING3[2]
  }),
  FEEDBACK_THUMBS: (0, import_uik3.css)({
    width: "22px",
    minWidth: "22px",
    height: "22px",
    "& svg": {
      width: "16px",
      height: "16px"
    }
  }),
  RESPONSE_BOTTOM_CONTAINER: (0, import_uik3.css)({
    borderTop: `2px solid ${BRAND_ACCENT_BORDER_WEAK2}`,
    paddingTop: SPACING3[4],
    marginTop: SPACING3[4],
    transition: "all  0.75s ease"
  })
};

// src/components/feedbackForm/FeedbackForm.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FeedbackForm = /* @__PURE__ */ __name(({
  query,
  conversationId,
  questionId,
  email,
  answer,
  isCSaas,
  isHelpCenter,
  cSaasPrefix,
  apiBasePath,
  onFeedbackClicked
}) => {
  const [positive, setPositive] = (0, import_react2.useState)(void 0);
  const [feedbackCompleted, setFeedbackCompleted] = (0, import_react2.useState)(false);
  const [textInput, setTextInput] = (0, import_react2.useState)("");
  const [selected, setSelected] = (0, import_react2.useState)({
    incorrect: false,
    notHelpful: false,
    unsafe: false,
    other: false,
    correct: false,
    helpful: false
  });
  const generateTagsForSubmit = /* @__PURE__ */ __name(() => {
    const tags = [];
    if (selected.incorrect) {
      tags.push("Incorrect");
    }
    if (selected.notHelpful) {
      tags.push("Not Helpful");
    }
    if (selected.unsafe) {
      tags.push("Unsafe");
    }
    if (selected.other) {
      tags.push("Other");
    }
    if (selected.correct) {
      tags.push("Correct");
    }
    if (selected.helpful) {
      tags.push("Helpful");
    }
    return tags;
  }, "generateTagsForSubmit");
  const handleSubmit = /* @__PURE__ */ __name((positiveFeedback2) => {
    const additionalFeedback = textInput;
    submitFeedback(
      positiveFeedback2.toString(),
      query,
      additionalFeedback,
      answer,
      generateTagsForSubmit(),
      conversationId,
      questionId,
      email,
      isCSaas,
      isHelpCenter,
      cSaasPrefix,
      apiBasePath
    ).catch((error) => {
      console.error(error);
    });
    setFeedbackCompleted(true);
  }, "handleSubmit");
  const handlePostiveThumbs = /* @__PURE__ */ __name(() => {
    if (positive === void 0) {
      setPositive(true);
      if (onFeedbackClicked) {
        onFeedbackClicked(true);
      }
    }
  }, "handlePostiveThumbs");
  const handleNegativeThumbs = /* @__PURE__ */ __name(() => {
    if (positive === void 0) {
      setPositive(false);
      if (onFeedbackClicked) {
        onFeedbackClicked(true);
      }
    }
    if (positive === false && !feedbackCompleted) {
      setPositive(void 0);
      if (onFeedbackClicked) {
        onFeedbackClicked(true);
      }
    }
  }, "handleNegativeThumbs");
  const handleCheckboxToggled = /* @__PURE__ */ __name((checked, type) => {
    setSelected((prev) => ({ ...prev, [type]: checked }));
  }, "handleCheckboxToggled");
  const handleCopy = (0, import_react2.useCallback)(() => {
    async function copyText() {
      await navigator.clipboard.writeText(answer);
    }
    __name(copyText, "copyText");
    copyText().catch((error) => console.error(error));
  }, [answer]);
  const positiveFeedback = {
    title: "Provide additional feedback (optional)",
    ratingTags: [
      { name: "Correct", labelId: "correct" },
      { name: "Helpful", labelId: "helpful" },
      { name: "Other", labelId: "other" }
    ]
  };
  const negativeFeedback = {
    title: "Why have you given this feedback? (optional)",
    ratingTags: [
      { name: "Incorrect", labelId: "incorrect" },
      { name: "Not Helpful", labelId: "notHelpful" },
      { name: "Unsafe", labelId: "unsafe" }
    ]
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: STYLES3.CONTAINER, "data-testid": "ai-feedback-form", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: STYLES3.FEEDBACK_THUMBS_CONTAINER, "data-testid": "ai-assistant-response-feedback", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_uik4.Button,
        {
          className: STYLES3.FEEDBACK_THUMBS,
          type: "TERTIARY",
          icon: "Action.ThumbsUp",
          onClick: handlePostiveThumbs,
          selected: positive,
          disabled: positive === false && positive !== void 0,
          "data-testid": "ai-assistant-response-thumbs-up"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_uik4.Button,
        {
          className: STYLES3.FEEDBACK_THUMBS,
          type: "TERTIARY",
          icon: "Action.ThumbsDown",
          onClick: handleNegativeThumbs,
          selected: positive === false && positive !== void 0,
          disabled: positive,
          "data-testid": "ai-assistant-response-thumbs-down"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_uik4.Button,
        {
          className: STYLES3.FEEDBACK_THUMBS,
          type: "TERTIARY",
          icon: "Action.Copy",
          onClick: handleCopy,
          "data-testid": "ai-assistant-response-copy"
        }
      )
    ] }),
    positive !== void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: STYLES3.RESPONSE_BOTTOM_CONTAINER, "data-testid": "ai-feedback-form-bottom", children: [
      !feedbackCompleted && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: STYLES3.HEADER_CONTAINER, children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: STYLES3.HEADER_TEXT, children: positive ? positiveFeedback.title : negativeFeedback.title }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_uik4.Button,
            {
              type: "TERTIARY",
              icon: "Action.Disable",
              onClick: () => setPositive(void 0),
              "data-testid": "ai-feedback-form-close-btn"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: STYLES3.SELECTIONS, children: (positive ? positiveFeedback.ratingTags : negativeFeedback.ratingTags).map((ratingTag) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_uik4.Checkbox,
          {
            label: ratingTag.name,
            onChange: (checked) => handleCheckboxToggled(checked, ratingTag.labelId),
            "data-testid": `ai-feedback-form-${ratingTag.labelId}`
          },
          ratingTag.labelId
        )) }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_uik4.Textarea,
          {
            rows: 6,
            maxRows: 6,
            placeholder: "Provide additional feedback",
            onChange: (e) => setTextInput(e.target.value),
            "data-testid": "ai-feedback-form-text-area"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: STYLES3.BUTTONS, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_uik4.Button, { type: "PRIMARY", onClick: () => handleSubmit(positive), "data-testid": "ai-feedback-form-submit-btn", children: "Submit" }) })
      ] }),
      feedbackCompleted && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { children: "Thank you for your feedback!" })
    ] })
  ] });
}, "FeedbackForm");

// src/components/aiButton/getStyles.ts
var import_uik5 = require("@appd/uik");
var {
  SPACING: SPACING4,
  COLORS: {
    INTERACT_BG_WEAK_DISABLED,
    INTERACT_BORDER_DISABLED,
    INTERACT_TEXT_DISABLED,
    INTERACT_BG_WEAK,
    INTERACT_BORDER_HOVER,
    INTERACT_BG_WEAK_HOVER,
    DEFAULT_TEXT
  }
} = import_uik5.MAGNETIC_TOKENS;
var getStyles = /* @__PURE__ */ __name((disabled) => (0, import_uik5.css)({
  paddingTop: SPACING4[1],
  paddingBottom: SPACING4[1],
  paddingLeft: SPACING4[2],
  paddingRight: SPACING4[2],
  borderRadius: "6px",
  fontWeight: "700",
  cursor: disabled ? "not-allowed" : "pointer",
  background: `linear-gradient(${INTERACT_BG_WEAK}, ${INTERACT_BG_WEAK}) padding-box,
            linear-gradient(220deg, #63fff7 0%, #00bceb 50%, #3b4eea 80%)  border-box  0/150% 100%`,
  border: `2px solid ${disabled ? INTERACT_BORDER_DISABLED : "transparent"}`,
  color: disabled ? INTERACT_TEXT_DISABLED : DEFAULT_TEXT,
  backgroundColor: disabled ? INTERACT_BG_WEAK_DISABLED : INTERACT_BG_WEAK,
  ":hover": disabled ? {} : {
    border: `2px solid ${disabled ? INTERACT_BORDER_DISABLED : INTERACT_BORDER_HOVER}`,
    background: INTERACT_BG_WEAK_HOVER,
    backgroundColor: INTERACT_BG_WEAK_HOVER
  }
}), "getStyles");

// src/components/aiButton/AIButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var AIButton = /* @__PURE__ */ __name(({ onClick, disabled, children }) => {
  const handleClick = /* @__PURE__ */ __name(() => {
    if (!disabled && onClick) {
      onClick();
    }
  }, "handleClick");
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("button", { type: "button", className: getStyles(disabled), onClick: handleClick, disabled, children });
}, "AIButton");

// src/components/aiRating/AIRating.tsx
var import_react3 = require("react");
var import_uik7 = require("@appd/uik");

// src/components/aiRating/RatingCheckboxItems.ts
var RatingCheckbox = class {
  static getStaticItems() {
    return [
      {
        id: 0,
        label: "Irrelevant information",
        active: false,
        type: "content"
      },
      {
        id: 1,
        label: "Inacurate information",
        active: false,
        type: "content"
      },
      {
        id: 2,
        label: "Too vague",
        active: false,
        type: "content"
      },
      {
        id: 3,
        label: "Incomplete",
        active: false,
        type: "content"
      },
      {
        id: 4,
        label: "Lack of context awareness",
        active: false,
        type: "content"
      },
      {
        id: 5,
        label: "Inability to handle ambiguity",
        active: false,
        type: "content"
      },
      {
        id: 6,
        label: "Tone of voice not right",
        active: false,
        type: "delivery"
      },
      {
        id: 7,
        label: "Grammatical or spelling Errors",
        active: false,
        type: "delivery"
      },
      {
        id: 8,
        label: "Extreme load times",
        active: false,
        type: "performance"
      },
      {
        id: 9,
        label: "Repetition of Mistake",
        active: false,
        type: "performance"
      },
      {
        id: 12,
        label: "Inappropriate content",
        active: false,
        type: "ethics"
      },
      {
        id: 13,
        label: "Security and privacy concerns",
        active: false,
        type: "ethics"
      },
      {
        id: 14,
        label: "Biased or discriminating response",
        active: false,
        type: "ethics"
      }
    ];
  }
};
__name(RatingCheckbox, "RatingCheckbox");

// src/components/aiRating/STYLES.ts
var import_uik6 = require("@appd/uik");
var STYLES4 = {
  MAIN: (0, import_uik6.css)({
    height: "5px",
    backgroundColor: "black",
    opacity: ".25",
    margin: "16px 0"
  }),
  HINT_CONTAINER: (0, import_uik6.css)({
    display: "flex",
    position: "relative",
    height: 20
  }),
  DIVIDER: (0, import_uik6.css)({
    height: "1px",
    backgroundColor: "black",
    opacity: ".25",
    margin: "16px 0"
  }),
  VERTICAL_FLEX: (0, import_uik6.css)({
    display: "flex",
    gap: 8,
    flexFlow: "column"
  }),
  SUBMITTED_CONTAINER: (0, import_uik6.css)({
    display: "flex",
    marginTop: 16,
    gap: 16,
    justifyContent: "flex-end"
  })
};

// src/components/aiRating/AIRating.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var INITIAL_RELEVANCE_RATING = 2;
var Rating = /* @__PURE__ */ __name(({
  questionString,
  questionId,
  answer,
  tags,
  email,
  model,
  selectedRole,
  conversationId
}) => {
  const [relevanceRating, setRelevanceRating] = (0, import_react3.useState)(INITIAL_RELEVANCE_RATING);
  const [checkboxes, setCheckboxes] = (0, import_react3.useState)(RatingCheckbox.getStaticItems());
  const [additionalFeedback, setAdditionalFeedback] = (0, import_react3.useState)("");
  const [submissionState, setSubmissionState] = (0, import_react3.useState)("Submit");
  const handleSubmit = /* @__PURE__ */ __name(async () => {
    setSubmissionState("Submitting");
    const ratingObj = {
      relevanceRating,
      question: questionString,
      answer,
      contentTags: checkboxes.filter((cb) => cb.type === "content" && cb.active).map((cb) => cb.label),
      deliveryTags: checkboxes.filter((cb) => cb.type === "delivery" && cb.active).map((cb) => cb.label),
      performanceTags: checkboxes.filter((cb) => cb.type === "performance" && cb.active).map((cb) => cb.label),
      ethicsTags: checkboxes.filter((cb) => cb.type === "ethics" && cb.active).map((cb) => cb.label),
      additionalFeedback,
      questionTags: tags.filter((a) => a.active).map((t) => t.label),
      email,
      model,
      role: selectedRole,
      conversationId,
      questionId
    };
    try {
      const response = await fetch(CONSTANTS.AI_INTERNAL_FEEDBACK, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(ratingObj)
      });
      if (!response.ok) {
        throw new Error(await response.text());
      }
      setSubmissionState("Submitted");
      setCheckboxes(RatingCheckbox.getStaticItems());
    } catch (error) {
      console.error("Failed to submit feedback:", error);
    }
  }, "handleSubmit");
  const handleOnClick = /* @__PURE__ */ __name((id) => {
    const newCheckboxes = checkboxes.map((c) => {
      if (c.id === id) {
        c.active = !c.active;
      }
      return c;
    });
    const ethicsOnly = newCheckboxes.filter((n) => n.type === "ethics");
    const hasEthicsChecked = ethicsOnly.find((e) => e.active);
    if (hasEthicsChecked) {
      setRelevanceRating(0);
    }
    setCheckboxes(newCheckboxes);
  }, "handleOnClick");
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { "data-testid": "ai-rating-container", children: submissionState === "Submitted" ? /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("hr", {}),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("p", { "data-testid": "thank-you-msg", children: "Thank you for your rating." })
  ] }) : /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Heading, { style: { marginTop: 16, marginBottom: 16 }, children: "Answer 1" }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.MAIN) }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_uik7.Heading, { children: [
      "Rate this answer: ",
      relevanceRating && /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
        relevanceRating,
        " / 4"
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_uik7.Slider,
      {
        max: 4,
        min: 0,
        initialUpper: INITIAL_RELEVANCE_RATING,
        onChange: (value) => setRelevanceRating(value.upper)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: `${(0, import_uik7.css)(STYLES4.HINT_CONTAINER)} hint`, children: [
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { style: { position: "absolute", left: 0 }, children: "Harmful" }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
        "div",
        {
          style: {
            position: "absolute",
            left: "calc(25% - 36px)"
          },
          children: "Unsuccessful"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { style: { position: "absolute", left: "calc(50% - 22px)" }, children: "Neutral" }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { style: { position: "absolute", left: "calc(75% - 26px)" }, children: "Effective" }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
        "div",
        {
          style: {
            position: "absolute",
            right: 0
          },
          children: "Exceeding"
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.DIVIDER) }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Heading, { style: { marginTop: 16, marginBottom: 16 }, children: "Why have you given this feedback?" }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { style: { display: "flex", gap: 8 }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Heading, { size: "SUB_SECTION", children: "Content" }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: checkboxes.filter((c) => c.type === "content").map((cc) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Checkbox, { onClick: () => handleOnClick(cc.id), checked: cc.active, label: cc.label }, cc.id)) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: [
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Heading, { size: "SUB_SECTION", children: "Delivery" }),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: checkboxes.filter((c) => c.type === "delivery").map((cc) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Checkbox, { onClick: () => handleOnClick(cc.id), checked: cc.active, label: cc.label }, cc.id)) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: [
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Heading, { size: "SUB_SECTION", children: "Performance" }),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: checkboxes.filter((c) => c.type === "performance").map((cc) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Checkbox, { onClick: () => handleOnClick(cc.id), checked: cc.active, label: cc.label }, cc.id)) })
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Heading, { size: "SUB_SECTION", children: "Ethics" }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.VERTICAL_FLEX), children: checkboxes.filter((c) => c.type === "ethics").map((cc) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Checkbox, { onClick: () => handleOnClick(cc.id), checked: cc.active, label: cc.label }, cc.id)) })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_uik7.Textarea,
      {
        style: { width: "100%", marginTop: 16 },
        placeholder: "Provide additional feedback",
        value: additionalFeedback,
        onChange: (e) => setAdditionalFeedback(e.target.value),
        rows: 4
      }
    ),
    submissionState === "Submitted" ? /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_uik7.css)(STYLES4.SUBMITTED_CONTAINER), "data-testid": "submitted-btn", children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("b", { children: "Submitted" }) }) : /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: (0, import_uik7.css)(STYLES4.SUBMITTED_CONTAINER), "data-testid": "submit-container", children: [
      submissionState === "Submit" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Button, { type: "TERTIARY", onClick: () => setSubmissionState("Skipped"), children: "Skip" }),
      submissionState === "Skipped" ? /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("b", { children: "Skipped" }) : (
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_uik7.Button, { "data-testid": "submit-btn", onClick: handleSubmit, children: submissionState })
      )
    ] })
  ] }) });
}, "Rating");

// src/components/aiResponse/AIResponseRenderer.tsx
var import_uik8 = require("@appd/uik");
var import_jsx_runtime4 = require("react/jsx-runtime");
var AIResponseRenderer = /* @__PURE__ */ __name(({ aiResponse }) => /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_jsx_runtime4.Fragment, { children: [
  renderMarkdown(aiResponse.text),
  aiResponse?.lineChart && aiResponse?.lineChart.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { style: { paddingBottom: 16 }, "data-testid": "ai-response-line-chart", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik8.Cartesian, { legend: true, children: aiResponse.lineChart.map((line) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik8.Cartesian.Line, { data: line }, generateUUID())) }) }),
  aiResponse?.table && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { style: { paddingBottom: 16 }, "data-testid": "ai-response-table", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_uik8.Grid,
    {
      className: (0, import_uik8.css)({ height: "142px" }),
      showConfigure: false,
      columns: aiResponse.table?.columns,
      rows: aiResponse.table?.rows
    }
  ) })
] }), "AIResponseRenderer");

// src/components/aiResponse/AIResponse.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var aiIcon = (
  // eslint-disable-next-line
  require_ai_avatar()
);
var AIResponse = /* @__PURE__ */ __name(({
  query,
  conversationId,
  questionId,
  controller,
  signal,
  email,
  setIsLoading,
  setIsReading,
  onCancel,
  handleSend,
  selectedRole,
  isAITrainingEnabled,
  model,
  tags,
  isCSaas,
  isHelpCenter,
  cSaasPrefix,
  apiBasePath,
  appName,
  appId
}) => {
  const requestBody = {
    query,
    conversationId,
    questionId,
    email,
    modelVersion: model,
    appName,
    appId
  };
  const { data, loading, reading, done, error, currentReader } = useFetchAIResponse(
    requestBody,
    signal,
    isCSaas,
    isHelpCenter,
    cSaasPrefix,
    apiBasePath
  );
  const [showTimeout, setShowTimeout] = (0, import_react4.useState)(false);
  const [streamCanceled, setStreamCanceled] = (0, import_react4.useState)(false);
  const [feedbackClicked, setFeedbackClicked] = (0, import_react4.useState)(false);
  const [recommendations, setRecommendations] = (0, import_react4.useState)([]);
  const TIMEOUT = 2e4;
  const TIMEOUT_MESSAGE = `I'm sorry, it's taking a bit longer than usual to find an answer. Would you like me to keep searching?`;
  const ERROR_MESSAGE = `I'm sorry, I can't answer this.`;
  const cancelStream = (0, import_react4.useCallback)(() => {
    if (currentReader) {
      currentReader.cancel().catch(() => {
      });
      setIsLoading(false);
      setIsReading(false);
    }
    setStreamCanceled(true);
  }, [currentReader, setIsLoading, setIsReading]);
  const cancelFetch = /* @__PURE__ */ __name(() => {
    if (!currentReader) {
      controller.abort();
    }
    onCancel();
  }, "cancelFetch");
  (0, import_react4.useEffect)(() => {
    setIsLoading(loading);
    const timeoutId = setTimeout(() => {
      setShowTimeout(true);
    }, TIMEOUT);
    if (!loading || done) {
      setShowTimeout(false);
      clearTimeout(timeoutId);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [loading, setIsLoading, done]);
  (0, import_react4.useEffect)(
    () => () => {
      cancelStream();
    },
    [cancelStream]
  );
  (0, import_react4.useEffect)(() => {
    setIsReading(reading);
    if (error) {
      setIsLoading(false);
      setIsReading(false);
    }
    if (done && error === null) {
      fetchRecommendations(4, questionId, isCSaas, isHelpCenter, cSaasPrefix, apiBasePath).then((response) => setRecommendations(response)).catch(() => {
      });
    }
  }, [
    error,
    done,
    setIsReading,
    questionId,
    reading,
    email,
    setIsLoading,
    isCSaas,
    isHelpCenter,
    cSaasPrefix,
    apiBasePath
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: STYLES2.CONTAINER, "data-testid": "ai-assistant-response", children: [
    loading && !error && !showTimeout ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_uik9.Spinner, { className: STYLES2.SPINNER, description: "Generating", size: "SMALL", "data-testid": "ai-assistant-spinner" }) : /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: STYLES2.RESPONSE_TEXT, children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: STYLES2.AVATAR, children: [
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("img", { src: aiIcon, alt: "ai-assistant-icon" }),
        "AI Assistant"
      ] }),
      error !== null && !streamCanceled ? ERROR_MESSAGE : /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(AIResponseRenderer, { aiResponse: data })
    ] }),
    showTimeout && TIMEOUT_MESSAGE,
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { children: [
      showTimeout && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: STYLES2.RESPONSE_BOTTOM_CONTAINER, children: /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: STYLES2.TIMEOUT_BUTTON_CONTAINER, children: [
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(AIButton, { onClick: () => setShowTimeout(false), children: "Yes" }),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(AIButton, { onClick: cancelFetch, children: "No" })
      ] }) }),
      done && !error && !isAITrainingEnabled && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        FeedbackForm,
        {
          query,
          conversationId,
          questionId,
          email,
          answer: data.text,
          onFeedbackClicked: setFeedbackClicked,
          isCSaas,
          isHelpCenter,
          cSaasPrefix,
          apiBasePath
        }
      ),
      done && !error && !feedbackClicked && recommendations.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: STYLES2.RESPONSE_BOTTOM_CONTAINER, children: [
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: STYLES2.RECOMMENDATIONS_TITLE, children: "Ask another question or choose a prompt below" }),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: STYLES2.RECOMMENDATIONS, children: recommendations.map((rec) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(AIButton, { onClick: () => handleSend(rec), children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_uik9.Tooltip, { value: rec.question, position: "TOP", showOnOverflowOnly: true, children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: STYLES2.RECOMMENDATIONS_BUTTON, children: rec.question }) }) }, rec.question.trim())) })
      ] }),
      isAITrainingEnabled && done && !error && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        Rating,
        {
          questionString: query,
          questionId,
          answer: data.text,
          tags,
          email,
          model,
          selectedRole,
          conversationId
        }
      )
    ] })
  ] });
}, "AIResponse");

// src/components/aiResponse/AIResponseStatic.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var AIResponseStatic = /* @__PURE__ */ __name(({
  conversationId,
  questionId,
  data,
  query,
  email,
  isCSaas,
  isHelpCenter,
  cSaasPrefix,
  apiBasePath
}) => /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: STYLES2.CONTAINER, "data-testid": "ai-assistant-response", children: [
  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: STYLES2.RESPONSE_TEXT, children: renderMarkdown(data) }),
  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    FeedbackForm,
    {
      query,
      conversationId,
      email,
      answer: data,
      questionId: questionId ?? "",
      isCSaas,
      isHelpCenter,
      cSaasPrefix,
      apiBasePath
    }
  ) })
] }), "AIResponseStatic");

// src/components/aiResponse/AIAnalyzeResponse.tsx
var import_uik10 = require("@appd/uik");
var import_react6 = require("react");

// src/hooks/useFetchAIAnalyzeResponse.ts
var import_react5 = require("react");
var useFetchAIAnalyzeResponse = /* @__PURE__ */ __name((requestBody, signal, isCSaas, cSaasPrefix, apiBasePath) => {
  const { conversationId, appName, appId, email, questionId } = requestBody;
  const [data, setData] = (0, import_react5.useState)({ text: "", analysis: null });
  const [fetching, setFetching] = (0, import_react5.useState)(false);
  const [reading, setReading] = (0, import_react5.useState)(false);
  const [error, setError] = (0, import_react5.useState)(null);
  const [done, setDone] = (0, import_react5.useState)(false);
  const [currentReader, setCurrentReader] = (0, import_react5.useState)(null);
  (0, import_react5.useEffect)(() => {
    setDone(false);
    const onData = /* @__PURE__ */ __name((res) => {
      setData(res);
    }, "onData");
    const onDone = /* @__PURE__ */ __name(() => {
      setDone(true);
    }, "onDone");
    const onStreamInit = /* @__PURE__ */ __name((reader) => {
      setCurrentReader(reader);
    }, "onStreamInit");
    const onError = /* @__PURE__ */ __name((err) => {
      if (err) {
        setError(err);
      }
      setDone(true);
    }, "onError");
    fetchAIAnalyzeResponse(
      requestBody,
      isCSaas,
      cSaasPrefix,
      apiBasePath,
      signal,
      onData,
      setFetching,
      setReading,
      onDone,
      onStreamInit,
      onError
    ).catch((err) => setError(err));
  }, [conversationId, email, questionId, appName, appId, signal, isCSaas]);
  return { data, done, error, currentReader };
}, "useFetchAIAnalyzeResponse");

// src/components/aiResponse/AIAnalyzeResponse.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var aiIcon2 = (
  // eslint-disable-next-line
  require_ai_avatar()
);
var AIAnalyzeResponse = /* @__PURE__ */ __name(({
  conversationId,
  questionId,
  controller,
  signal,
  email,
  setIsLoading,
  setIsReading,
  handleSend,
  onCancel,
  isCSaas,
  cSaasPrefix,
  apiBasePath,
  appName,
  appId
}) => {
  const [loading, setLoading] = (0, import_react6.useState)(true);
  const requestBody = {
    conversationId,
    questionId,
    email,
    appName: appName ?? "",
    appId: appId ?? "0"
  };
  const { data, done, error, currentReader } = useFetchAIAnalyzeResponse(
    requestBody,
    signal,
    isCSaas,
    cSaasPrefix,
    apiBasePath
  );
  const [showTimeout, setShowTimeout] = (0, import_react6.useState)(false);
  const [streamCanceled, setStreamCanceled] = (0, import_react6.useState)(false);
  const ERROR_MESSAGE = `I'm sorry, I can't answer this.`;
  const cancelStream = (0, import_react6.useCallback)(() => {
    if (currentReader) {
      currentReader.cancel().catch(() => {
      });
      setIsLoading(false);
      setLoading(false);
      setIsReading(false);
    }
    setStreamCanceled(true);
  }, [currentReader, setIsLoading, setIsReading]);
  const cancelFetch = /* @__PURE__ */ __name(() => {
    if (!currentReader) {
      controller.abort();
    }
    onCancel();
  }, "cancelFetch");
  (0, import_react6.useEffect)(() => {
    if (done) {
      setShowTimeout(false);
    }
  }, [loading, setIsLoading, done]);
  (0, import_react6.useEffect)(
    () => () => {
      cancelStream();
    },
    [cancelStream]
  );
  (0, import_react6.useEffect)(() => {
    if (error || data.text) {
      setIsLoading(false);
      setLoading(false);
    }
  }, [error, setIsLoading, data.text]);
  const formatKey = /* @__PURE__ */ __name((key) => {
    const splitString = key.split("_").join(" ");
    return splitString.charAt(0).toUpperCase() + splitString.slice(1);
  }, "formatKey");
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: STYLES2.CONTAINER, "data-testid": "ai-assistant-response", children: [
    loading && !error && !showTimeout ? /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_uik10.Spinner, { className: STYLES2.SPINNER, description: "Generating", size: "SMALL", "data-testid": "ai-assistant-spinner" }) : /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: STYLES2.RESPONSE_TEXT, children: [
      /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: STYLES2.AVATAR, children: [
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("img", { src: aiIcon2, alt: "ai-assistant-icon" }),
        "AI Assistant"
      ] }),
      error !== null && !streamCanceled ? ERROR_MESSAGE : renderMarkdown(data.text),
      data?.analysis && Object.entries(data?.analysis).map(([key, value], index) => /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { id: "analyze-response-renderer-container", className: STYLES2.ANALYZE_CONTAINER, children: [
        /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("span", { className: STYLES2.ANALYZE_TEXT_START, children: [
          index + 1,
          ". ",
          formatKey(key)
        ] }),
        ":",
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          AIResponseRenderer,
          {
            aiResponse: { text: value.text, lineChart: value["chart:line"], table: value["chart:table"] }
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: STYLES2.ANALYZE_REC, children: value?.recommendation?.map((rec) => /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          import_uik10.Button,
          {
            type: "SECONDARY",
            onClick: () => handleSend({ question: rec, model: getDefaultModel(isCSaas) }),
            children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_uik10.Tooltip, { value: rec, position: "TOP", showOnOverflowOnly: true, children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: STYLES2.RECOMMENDATIONS_BUTTON, children: rec }) })
          },
          key
        )) })
      ] }, key))
    ] }),
    showTimeout,
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { children: showTimeout && /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: STYLES2.RESPONSE_BOTTOM_CONTAINER, children: /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: STYLES2.TIMEOUT_BUTTON_CONTAINER, children: [
      /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(AIButton, { onClick: () => setShowTimeout(false), children: "Yes" }),
      /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(AIButton, { onClick: cancelFetch, children: "No" })
    ] }) }) })
  ] });
}, "AIAnalyzeResponse");

// src/components/aiWelcome/STYLES.ts
var import_uik11 = require("@appd/uik");
var {
  TYPOGRAPHY: { HEADING_PRIMARY, P4_DEFAULT: P4_DEFAULT2 },
  SPACING: SPACING5
} = import_uik11.MAGNETIC_TOKENS;
var STYLES5 = {
  MAIN_CONTAINER: (0, import_uik11.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingBottom: SPACING5[6]
  }),
  SUB_CONTAINER: (0, import_uik11.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    flexDirection: "column",
    maxWidth: 310,
    textAlign: "center",
    minHeight: 400
  }),
  HEADER: (0, import_uik11.css)({
    font: HEADING_PRIMARY,
    textAlign: "center",
    marginBottom: 8,
    marginTop: 24
  }),
  SUB_TEXT: (0, import_uik11.css)({
    textAlign: "center",
    font: P4_DEFAULT2
  })
};

// src/components/aiWelcome/AIWelcome.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var logo = require_ai_logo_large();
var AIWelcome = /* @__PURE__ */ __name(() => /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: STYLES5.MAIN_CONTAINER, "data-testid": "ai-welcome", children: /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: STYLES5.SUB_CONTAINER, children: [
  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("img", { src: logo, alt: "AI logo", "data-testid": "ai-welcome-logo" }),
  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: STYLES5.HEADER, children: "How can I help you today?" }),
  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: STYLES5.SUB_TEXT, children: "Ask me question about the product or choose one of the recommended prompts." })
] }) }), "AIWelcome");

// src/components/aiError/STYLES.ts
var import_uik12 = require("@appd/uik");
var {
  COLORS: { CONTROL_BG_STRONG: CONTROL_BG_STRONG2 },
  TYPOGRAPHY: { WEIGHT_EMPHASIS: WEIGHT_EMPHASIS3, HEADING_SMALLEST: HEADING_SMALLEST2, P4_DEFAULT: P4_DEFAULT3 },
  SPACING: SPACING6
} = import_uik12.MAGNETIC_TOKENS;
var STYLES6 = {
  FLEX_CONTAINER: (0, import_uik12.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }),
  CONTAINER: (0, import_uik12.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    maxWidth: 240,
    textAlign: "center",
    minHeight: 400,
    height: "72vh"
  }),
  MAIN_TEXT: (0, import_uik12.css)({
    font: HEADING_SMALLEST2,
    textAlign: "center",
    marginBottom: SPACING6[1],
    marginTop: SPACING6[3]
  }),
  SUB_TEXT: (0, import_uik12.css)({
    textAlign: "center",
    font: P4_DEFAULT3
  }),
  LINK_TEXT: (0, import_uik12.css)({
    color: CONTROL_BG_STRONG2,
    textDecoration: "none",
    fontWeight: WEIGHT_EMPHASIS3
  })
};

// src/components/aiError/AIError.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var empty = require_empty_state();
var AIError = /* @__PURE__ */ __name(() => {
  const MAIN_TEXT = "This page couldn't be reached";
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: STYLES6.FLEX_CONTAINER, "data-testid": "ai-assistant-error", children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: STYLES6.CONTAINER, children: [
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("img", { src: empty, alt: "Error" }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: STYLES6.MAIN_TEXT, children: MAIN_TEXT }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: STYLES6.SUB_TEXT, children: [
      "Try reloading the page. If the issue persists, submit a",
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("a", { className: STYLES6.LINK_TEXT, target: "_blank", rel: "noreferrer", href: CONSTANTS.SUPPORT_URL, children: "support ticket" }),
      " ",
      "and we will help you resolve it."
    ] })
  ] }) });
}, "AIError");

// src/components/trainAIInput/TrainAIInput.tsx
var import_uik14 = require("@appd/uik");

// src/components/trainAIInput/STYLES.ts
var import_uik13 = require("@appd/uik");
var {
  COLORS: { BRAND_BG_FOCUS, DEFAULT_TEXT: DEFAULT_TEXT2 },
  TYPOGRAPHY: { WEIGHT_DEFAULT, WEIGHT_EMPHASIS: WEIGHT_EMPHASIS4 },
  SPACING: SPACING7
} = import_uik13.MAGNETIC_TOKENS;
var STYLES7 = {
  CONTAINER: (0, import_uik13.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: 700,
    marginTop: 0
  }),
  VERTICAL_DIV: (0, import_uik13.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "16px",
    gap: "4px"
  }),
  HISTORY: (0, import_uik13.css)({
    display: "flex",
    flexDirection: "column-reverse",
    justifyContent: "flex-end",
    gap: SPACING7[3],
    flexGrow: 10,
    height: "100px",
    overflowY: "auto",
    "& button": {
      color: DEFAULT_TEXT2,
      fontWeight: WEIGHT_DEFAULT
    }
  }),
  HISTORY_SECTION: (0, import_uik13.css)({
    fontWeight: WEIGHT_EMPHASIS4,
    color: BRAND_BG_FOCUS
  }),
  HISTORY_SECTION_ITEMS: (0, import_uik13.css)({
    display: "flex",
    flexDirection: "column-reverse"
  }),
  HISTORY_BUTTON: (0, import_uik13.css)({})
};

// src/components/trainAIInput/TrainAIInput.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var TrainAIInput = /* @__PURE__ */ __name(({
  tags,
  setTags,
  selectedRole,
  setSelectedRole,
  roleOptions: roleOptions2
}) => {
  const handleOnClick = /* @__PURE__ */ __name((tag) => {
    const newTags = tags.map((t) => {
      if (t.id === tag.id) {
        t.active = !t.active;
      }
      return t;
    });
    setTags(newTags);
  }, "handleOnClick");
  const findSelectedIndex = /* @__PURE__ */ __name(() => roleOptions2.findIndex((option) => option.value === selectedRole), "findSelectedIndex");
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: (0, import_uik14.css)(STYLES7.CONTAINER), "data-testid": "train-ai-input-container", children: [
    /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: (0, import_uik14.css)(STYLES7.VERTICAL_DIV), children: [
      /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("b", { style: { fontSize: "12px" }, children: "Your Role" }),
      /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        import_uik14.Select,
        {
          showClear: false,
          style: { width: 175 },
          onChange: (value) => setSelectedRole(roleOptions2[value[0]]),
          value: [findSelectedIndex()],
          children: roleOptions2.map(({ label }) => /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_uik14.Select.Option, { children: label }, label))
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: (0, import_uik14.css)(STYLES7.VERTICAL_DIV), children: [
      /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("b", { style: { fontSize: "12px" }, children: "Focus of Evaluation" }),
      /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { style: { display: "flex", gap: 16 }, children: tags.map((t) => /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_uik14.Checkbox, { onClick: () => handleOnClick(t), label: t.label, checked: t.active }, t.label)) })
    ] })
  ] });
}, "TrainAIInput");

// src/utils/getIdentityURL.ts
var getIdentityUrl = /* @__PURE__ */ __name(() => {
  const isLocal = window.location.hostname.includes("localhost");
  const isAppdTest = window.location.hostname.includes("appd-test.com");
  return isLocal || isAppdTest ? CONSTANTS.IDENTITY_URL_LOCAL : CONSTANTS.IDENTITY_URL_PROD;
}, "getIdentityUrl");

// src/components/aiAssistant/AIAssistant.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var plane = require_airplane();
var roleOptions = [
  {
    id: 0,
    label: "Engineering",
    value: "Engineering"
  },
  {
    id: 1,
    label: "Info Experience",
    value: "Info Experience"
  },
  {
    id: 2,
    label: "Product Management",
    value: "Product Management"
  },
  {
    id: 3,
    label: "SPE",
    value: "SPE"
  },
  {
    id: 4,
    label: "Customer Enablement",
    value: "Customer Enablement"
  }
];
var AIAssistant = /* @__PURE__ */ __name(({
  activeConversationId,
  email,
  historyItems,
  modelOption,
  isAITrainingMode = false,
  isCSaas,
  isHelpCenter,
  cSaasPrefix,
  apiBasePath,
  appName,
  appId
}) => {
  const controller = (0, import_react7.useRef)(new AbortController());
  const [activeConversation, setActiveConversation] = (0, import_react7.useState)({
    id: activeConversationId ?? generateUUID(),
    items: historyItems?.length ? [...historyItems] : []
  });
  const [inputValue, setInputValue] = (0, import_react7.useState)("");
  const [isLoading, setIsLoading] = (0, import_react7.useState)(false);
  const [isReading, setIsReading] = (0, import_react7.useState)(false);
  const [fetchedEmail, setFetchedEmail] = (0, import_react7.useState)("");
  const [showError, setShowError] = (0, import_react7.useState)(false);
  const [responseRecommendation, setResponseRecommendation] = (0, import_react7.useState)();
  const [recommendations, setRecommendations] = (0, import_react7.useState)([]);
  const [initAnalysisDone, setInitAnalysisDone] = (0, import_react7.useState)(false);
  const chatContainer = (0, import_react7.useRef)(null);
  const answerRef = (0, import_react7.useRef)(null);
  const sendRef = (0, import_react7.useRef)(null);
  const inputRef = (0, import_react7.useRef)(null);
  const [tags, setTags] = (0, import_react7.useState)([
    { id: 0, label: "Content", active: false },
    { id: 1, label: "Delivery", active: false },
    { id: 2, label: "Performance", active: false },
    { id: 3, label: "Ethics", active: false }
  ]);
  const [selectedRole, setSelectedRole] = (0, import_react7.useState)(roleOptions[1]);
  const [models, setModels] = (0, import_react7.useState)();
  const [modelOne, setModelOne] = (0, import_react7.useState)({
    value: "rag_gpt4_original_1.0.0"
  });
  const [modelTwo, setModelTwo] = (0, import_react7.useState)({
    value: "rag_gpt3.5_original_1.0.0"
  });
  const [modelLabelOne, setModelLabelOne] = (0, import_react7.useState)("Select model");
  const [modelLabelTwo, setModelLabelTwo] = (0, import_react7.useState)("Select model");
  const SCROLL_OFFSET = 252;
  const FOOTER_TEXT = "The AI assistant may display inaccurate information. Make sure  to verify the responses.\n View our FAQs to learn more.";
  const scrollBottom = /* @__PURE__ */ __name(() => {
    if (chatContainer.current) {
      const { scrollHeight } = chatContainer.current;
      chatContainer.current?.scrollTo(0, scrollHeight);
    }
  }, "scrollBottom");
  const handleCancel = (0, import_react7.useCallback)(() => {
    if (controller.current) {
      controller.current.abort();
    }
    if (!isReading) {
      setActiveConversation((current) => {
        const newItems = current.items.slice(0, -1);
        return {
          id: current.id,
          items: newItems
        };
      });
    }
    setIsLoading(false);
  }, [isReading]);
  (0, import_react7.useEffect)(() => {
    if (!isHelpCenter && activeConversationId && historyItems) {
      setActiveConversation({ id: activeConversationId, items: [...historyItems] });
    }
  }, [activeConversationId, historyItems, isHelpCenter]);
  (0, import_react7.useEffect)(() => {
    if (!initAnalysisDone && activeConversationId && historyItems?.length === 0) {
      controller.current = new AbortController();
      const { signal } = controller.current;
      const answerId = generateUUID();
      const item = {
        id: answerId,
        type: "answer",
        answer: [
          {
            id: answerId,
            content: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              AIAnalyzeResponse,
              {
                conversationId: activeConversationId,
                questionId: generateUUID(),
                controller: controller.current,
                signal,
                email: email ?? fetchedEmail,
                onCancel: handleCancel,
                setIsLoading,
                setIsReading,
                isCSaas,
                handleSend: setResponseRecommendation,
                cSaasPrefix,
                appName,
                appId,
                apiBasePath
              }
            )
          }
        ]
      };
      setActiveConversation({ id: activeConversationId, items: [item] });
      setInitAnalysisDone(true);
    }
  }, [
    activeConversationId,
    isCSaas,
    historyItems?.length,
    cSaasPrefix,
    handleCancel,
    initAnalysisDone,
    appName,
    appId,
    email,
    fetchedEmail,
    apiBasePath
  ]);
  (0, import_react7.useEffect)(() => {
    if (inputRef && !isLoading && !isReading && !showError) {
      inputRef.current?.focus();
    }
  }, [inputRef, isLoading, isReading, showError]);
  (0, import_react7.useEffect)(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (chatContainer.current) {
        const { offsetHeight, scrollHeight, scrollTop } = chatContainer.current;
        if (scrollTop + offsetHeight + SCROLL_OFFSET >= scrollHeight) {
          scrollBottom();
        }
      }
    });
    if (answerRef.current) {
      resizeObserver.observe(answerRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [activeConversation]);
  const getModels = /* @__PURE__ */ __name(async () => {
    try {
      const response = await fetch(CONSTANTS.AI_TRAINING_MODELS, {
        method: "get",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        }
      });
      if (!response.ok || !response.body) {
        throw new Error(response.statusText);
      }
      const res = await response.text();
      const allModels = JSON.parse(res);
      const formattedModels = allModels.models?.map((m) => ({
        label: m.model_version,
        value: m.model_version
      }));
      setModels(formattedModels);
      setModelOne(formattedModels[0]);
    } catch (error) {
      console.error(error);
    }
  }, "getModels");
  (0, import_react7.useEffect)(() => {
    fetchAIHealth(isCSaas, isHelpCenter, cSaasPrefix, apiBasePath).then((resp) => {
      if (resp.status === "Healthy" || resp.status === "up" || resp.status === "Unknown") {
        setShowError(false);
        if (isHelpCenter) {
          fetchRecommendations(2, null, isCSaas, isHelpCenter, cSaasPrefix, apiBasePath).then((response) => setRecommendations(response)).catch(() => {
          });
        }
      } else {
        setShowError(true);
      }
    }).catch(() => {
    });
    if (isAITrainingMode) {
      void getModels();
    }
  }, [isCSaas, isHelpCenter, isAITrainingMode, cSaasPrefix, apiBasePath]);
  const handleSetAnswer = (0, import_react7.useCallback)(
    (cArray, conversationId, questionId, queryString, model) => {
      const answerId = generateUUID();
      const subAnswerId = generateUUID();
      const subAnswerIdTwo = generateUUID();
      controller.current = new AbortController();
      const { signal } = controller.current;
      let answerModel = model ?? getDefaultModel(isCSaas);
      if (responseRecommendation) {
        answerModel = responseRecommendation.model;
        setResponseRecommendation(void 0);
      }
      const answer = {
        id: answerId,
        type: "answer",
        answer: [
          {
            id: subAnswerId,
            content: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { ref: answerRef, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              AIResponse,
              {
                query: queryString ?? inputValue,
                questionId,
                setIsLoading,
                setIsReading,
                conversationId,
                onCancel: handleCancel,
                controller: controller.current,
                signal,
                email: email ?? fetchedEmail,
                handleSend: setResponseRecommendation,
                selectedRole: selectedRole.value,
                tags,
                isAITrainingEnabled: isAITrainingMode,
                model: isAITrainingMode ? modelOne.value : answerModel,
                isCSaas,
                isHelpCenter,
                cSaasPrefix,
                apiBasePath,
                appName,
                appId
              }
            ) })
          },
          ...modelOption === "two" ? [
            {
              id: subAnswerIdTwo,
              content: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { ref: answerRef, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                AIResponse,
                {
                  query: queryString ?? inputValue,
                  questionId,
                  setIsLoading,
                  setIsReading,
                  conversationId,
                  onCancel: handleCancel,
                  controller: controller.current,
                  signal,
                  email: email ?? fetchedEmail,
                  handleSend: setResponseRecommendation,
                  selectedRole: selectedRole.value,
                  tags,
                  isAITrainingEnabled: isAITrainingMode,
                  model: isAITrainingMode ? modelTwo.value : void 0,
                  isCSaas,
                  isHelpCenter,
                  cSaasPrefix,
                  apiBasePath
                }
              ) })
            }
          ] : []
        ]
      };
      const conversationWithAnswer = [...cArray, answer];
      setActiveConversation((previousConversation) => ({
        id: previousConversation.id,
        items: conversationWithAnswer
      }));
      scrollBottom();
    },
    [
      responseRecommendation,
      inputValue,
      handleCancel,
      email,
      fetchedEmail,
      selectedRole.value,
      tags,
      isAITrainingMode,
      modelOne.value,
      isCSaas,
      isHelpCenter,
      cSaasPrefix,
      apiBasePath,
      appName,
      appId,
      modelOption,
      modelTwo.value
    ]
  );
  const handleSend = (0, import_react7.useCallback)(
    (queryString, model) => {
      setInputValue("");
      setIsLoading(true);
      const questionId = generateUUID();
      const item = {
        id: questionId,
        query: queryString ?? inputValue,
        type: "question"
      };
      const newConversationItems = [...activeConversation.items, item];
      setActiveConversation((previousConversation) => ({
        id: previousConversation.id,
        items: newConversationItems
      }));
      handleSetAnswer(newConversationItems, activeConversation.id, questionId, queryString, model);
      setResponseRecommendation(void 0);
    },
    [activeConversation, handleSetAnswer, inputValue]
  );
  (0, import_react7.useEffect)(() => {
    if (!isCSaas) {
      const identityApiUrl = getIdentityUrl();
      fetch(identityApiUrl, {
        method: "get",
        headers: {
          Accept: "*/*"
        }
      }).then((response) => response.json()).then((data) => {
        if (data.user && data.user.email) {
          setFetchedEmail(data.user.email);
        }
      }).catch((error) => console.error(error));
    }
  }, [isCSaas]);
  (0, import_react7.useEffect)(() => {
    if (responseRecommendation && responseRecommendation.question !== "") {
      setInputValue(responseRecommendation.question);
      setTimeout(() => {
        sendRef.current?.click();
      }, 150);
    }
  }, [responseRecommendation]);
  const keyDownHandler = /* @__PURE__ */ __name((event) => {
    if (event.key === "Enter" && inputValue !== "") {
      event.preventDefault();
      handleSend();
    }
  }, "keyDownHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { id: "fso-ui-shell-ai-assistant", className: STYLES.CONTAINER, "data-testid": "ai-assistant-container", children: [
    isAITrainingMode && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: (0, import_uik15.css)(STYLES.MODEL_ONE_DROPDOWN), children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
        import_uik15.Dropdown,
        {
          kind: "SECONDARY",
          label: modelLabelOne,
          onSelect: (selected) => {
            if (models) {
              setModelOne({ value: models[selected[0]].value });
              setModelLabelOne(models[selected[0]].label);
            }
          },
          children: models && models.map((model) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_uik15.Dropdown.Option, { children: model.value }, model.value))
        }
      ) }),
      modelOption === "two" && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { style: { flex: 1, marginLeft: "8px" }, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
        import_uik15.Dropdown,
        {
          kind: "SECONDARY",
          label: modelLabelTwo,
          onSelect: (selected) => {
            if (models) {
              setModelTwo({ value: models[selected[0]].value });
              setModelLabelTwo(models[selected[0]].label);
            }
          },
          children: models && models.map((model) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_uik15.Dropdown.Option, { children: model.value }, model.value))
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: (0, import_uik15.css)(STYLES.CONVERSATION_CONTAINER), children: [
      activeConversation.items.length ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: STYLES.CONVERSATION, ref: chatContainer, children: activeConversation.items.map((conversationItem) => {
        if (conversationItem.type === "question" && modelOption === "two") {
          return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { style: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_uik15.Heading, { className: (0, import_uik15.css)(STYLES.QUESTION), "data-testid": "ai-conversation-question-heading", children: conversationItem.query }) }, conversationItem.id);
        }
        if (conversationItem.type === "question") {
          return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: STYLES.QUESTION, "data-testid": "ai-conversation-question", children: conversationItem.query }, conversationItem.id);
        }
        return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { "data-testid": "ai-conversation-answer", style: { display: "flex" }, children: conversationItem.answer?.map((answerItem) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: STYLES.ANSWER, style: { flex: 1 }, children: answerItem.content }, answerItem.id)) }, conversationItem.id);
      }) }) : /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_jsx_runtime11.Fragment, { children: [
        showError && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(AIError, {}),
        isHelpCenter && !showError && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(AIWelcome, {}),
        isHelpCenter && recommendations.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: STYLES.MACRO_CONTAINER, "data-testid": "ai-assistant-recs", children: recommendations.map((recommendation) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          import_uik15.Button,
          {
            style: {
              width: "100%",
              maxWidth: "800px",
              maxHeight: "68px",
              display: "flex",
              justifyContent: "center",
              marginBottom: "8px"
            },
            type: "MACRO",
            onClick: () => handleSend(recommendation.question, recommendation.model),
            children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_uik15.Tooltip, { value: recommendation.question, position: "TOP", showOnOverflowOnly: true, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { className: STYLES.MACRO_CONTENT, children: recommendation.question }) })
          },
          recommendation.question.trim()
        )) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { "data-testid": "input-container", className: STYLES.INPUT_CONTAINER, children: [
        /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          import_uik15.Input,
          {
            autoFocus: true,
            className: STYLES.INPUT,
            placeholder: "Ask the Cisco AI Assistant a question",
            value: inputValue,
            onChange: (e) => setInputValue(e.target.value),
            onKeyDown: keyDownHandler,
            disabled: isLoading || isReading || showError,
            "data-testid": "ai-assistant-input",
            ref: inputRef
          }
        ),
        isLoading || isReading ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_uik15.Button, { type: "SECONDARY", onClick: handleCancel, "data-testid": "ai-assistant-cancel", children: "Stop" }) : /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          import_uik15.Button,
          {
            type: "TERTIARY",
            disabled: isLoading || showError,
            onClick: () => handleSend(),
            "data-testid": "ai-assistant-submit",
            ref: sendRef,
            children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("img", { src: plane, alt: "submit" })
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: STYLES.FOOTER, children: isAITrainingMode ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
        TrainAIInput,
        {
          tags,
          setTags,
          selectedRole: selectedRole.value,
          setSelectedRole,
          roleOptions
        }
      ) : FOOTER_TEXT })
    ] })
  ] });
}, "AIAssistant");

// src/components/aiChatWindow/AIChatWindow.tsx
var import_uik21 = require("@appd/uik");
var import_react8 = require("react");

// src/components/aiChatWindow/STYLES.ts
var import_uik16 = require("@appd/uik");
var {
  SPACING: SPACING8,
  COLORS: { DEFAULT_BG }
} = import_uik16.MAGNETIC_TOKENS;
var STYLES8 = {
  MAIN_CONTAINER: (0, import_uik16.css)({
    backgroundColor: DEFAULT_BG,
    width: "1088px"
  }),
  MAIN_CONTAINER_CSAAS: (0, import_uik16.css)({
    backgroundColor: DEFAULT_BG,
    height: "800px"
  }),
  FULLSIZE_MAIN_CONTAINER: (0, import_uik16.css)({
    width: "100%"
  }),
  MAIN_CONTENT: (0, import_uik16.css)({
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    height: "100%",
    gap: SPACING8[2],
    maxHeight: "690px"
  }),
  FULLSIZE_MAIN_CONTENT: (0, import_uik16.css)({
    maxHeight: "80vh"
  }),
  LEFT_PANEL: (0, import_uik16.css)({
    display: "flex"
  }),
  RIGHT_PANEL: (0, import_uik16.css)({
    display: "flex",
    flexGrow: 10,
    height: "100%",
    minWidth: 0
  }),
  RIGHT_PANEL_CARD: (0, import_uik16.css)({
    flexGrow: 10,
    border: "none"
  }),
  HEADER: (0, import_uik16.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }),
  HEADER_RIGHT_CONTAINER: (0, import_uik16.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: SPACING8[4]
  })
};

// src/components/aiConversationHistory/AIConversationHistory.tsx
var import_uik20 = require("@appd/uik");

// src/components/aiConversationHistory/STYLES.ts
var import_uik17 = require("@appd/uik");
var {
  COLORS: { BRAND_BG_FOCUS: BRAND_BG_FOCUS2, DEFAULT_TEXT: DEFAULT_TEXT3, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM2 },
  TYPOGRAPHY: { P3_BOLD, WEIGHT_DEFAULT: WEIGHT_DEFAULT2, WEIGHT_EMPHASIS: WEIGHT_EMPHASIS5, WEIGHT_BOLD },
  SPACING: SPACING9
} = import_uik17.MAGNETIC_TOKENS;
var STYLES9 = {
  MAIN: (0, import_uik17.css)({
    border: "none",
    display: "flex",
    flexDirection: "column",
    width: "250px",
    height: "100%",
    padding: SPACING9[2]
  }),
  TOP_TITLE: (0, import_uik17.css)({
    font: P3_BOLD,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: SPACING9[3]
  }),
  HISTORY: (0, import_uik17.css)({
    display: "flex",
    flexDirection: "column-reverse",
    justifyContent: "flex-end",
    gap: SPACING9[3],
    flexGrow: 10,
    height: "100px",
    overflowY: "initial",
    "& button": {
      color: DEFAULT_TEXT3,
      fontWeight: WEIGHT_DEFAULT2
    }
  }),
  HISTORY_DATE: (0, import_uik17.css)({
    padding: SPACING9[2],
    color: DEFAULT_TEXT_MEDIUM2,
    fontWeight: WEIGHT_BOLD
  }),
  HISTORY_SECTION: (0, import_uik17.css)({
    fontWeight: WEIGHT_EMPHASIS5,
    color: BRAND_BG_FOCUS2
  }),
  HISTORY_SECTION_ITEMS: (0, import_uik17.css)({
    display: "flex",
    flexDirection: "column-reverse"
  }),
  HISTORY_BUTTON: (0, import_uik17.css)({})
};

// src/components/aiThreads/aiThreads.tsx
var import_uik19 = require("@appd/uik");

// src/components/aiThreads/STYLES.ts
var import_uik18 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT4, DEFAULT_BG_ACTIVE, DEFAULT_BG_HOVER },
  TYPOGRAPHY: { WEIGHT_DEFAULT: WEIGHT_DEFAULT3 },
  SPACING: SPACING10
} = import_uik18.MAGNETIC_TOKENS;
var STYLES10 = {
  THREAD: (0, import_uik18.css)({
    padding: SPACING10[2],
    borderRadius: SPACING10[2],
    color: DEFAULT_TEXT4,
    fontWeight: WEIGHT_DEFAULT3,
    "&:hover": {
      backgroundColor: DEFAULT_BG_HOVER,
      cursor: "pointer"
    }
  }),
  SELECTED_THREAD: (0, import_uik18.css)({
    backgroundColor: DEFAULT_BG_ACTIVE
  })
};

// src/components/aiThreads/aiThreads.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var Thread = /* @__PURE__ */ __name(({
  conversation,
  handleThreadClick,
  isSelected,
  conversationsId,
  value
}) => /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(import_uik19.Tooltip, { value: conversation?.question ?? "", showOnOverflowOnly: true, children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
  "div",
  {
    className: `${(0, import_uik19.css)(import_uik19.MAGNETIC_TOKENS.TYPOGRAPHY.ELLIPSES.END)} ${STYLES10.THREAD} 
    ${isSelected ? STYLES10.SELECTED_THREAD : ""}`,
    onClick: () => handleThreadClick(conversationsId),
    role: "button",
    tabIndex: 0,
    children: value
  }
) }, generateUUID()), "Thread");

// src/components/aiConversationHistory/AIConversationHistory.tsx
var import_jsx_runtime13 = require("react/jsx-runtime");
var AIConversationHistory = /* @__PURE__ */ __name(({
  history,
  currentThread,
  onNewConversation,
  onSelect,
  appName
}) => {
  const handleThreadClick = /* @__PURE__ */ __name((id) => {
    onSelect(id);
  }, "handleThreadClick");
  const getLabel = /* @__PURE__ */ __name((item) => {
    if (item) {
      if (item.question !== "") {
        return item.question;
      }
      if (item.question === "" && item.answer !== "") {
        return item.answer;
      }
      return item.updatedAt;
    }
    const capitalizedAppName = appName.charAt(0).toUpperCase() + appName.slice(1);
    return `${capitalizedAppName} Triage`;
  }, "getLabel");
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(import_uik20.Card, { className: STYLES9.MAIN, children: [
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: STYLES9.TOP_TITLE, "data-testid": "ai-convo-history-header", children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(AIButton, { onClick: onNewConversation, children: "New Thread" }) }),
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: STYLES9.HISTORY, "data-testid": "ai-convo-history-container", children: history.length > 0 && history.map(
      (item) => item.conversationIds.length >= 1 && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { className: STYLES9.HISTORY_SECTION, children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: STYLES9.HISTORY_DATE, children: item.date }),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: STYLES9.HISTORY_SECTION_ITEMS, children: item.conversationIds.map((conversation) => /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          Thread,
          {
            conversation: conversation.history[0],
            isSelected: conversation.id === currentThread,
            conversationsId: conversation.id,
            handleThreadClick,
            value: getLabel(conversation.history[0])
          },
          conversation.id
        )) })
      ] }, item.date)
    ) })
  ] });
}, "AIConversationHistory");

// src/components/aiChatWindow/AIChatWindow.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
var { Container } = import_uik21.Card;
var AIChatWindow = /* @__PURE__ */ __name(({
  onCloseClick,
  isAITrainingEnabled,
  setFullScreen,
  toggleFullScreen,
  isFullScreen,
  isCSaas,
  cSaasEmail,
  cSaasPrefix,
  apiBasePath,
  appName,
  appId
}) => {
  const [activeConversationId, setActiveConversationId] = (0, import_react8.useState)(generateUUID());
  const [activeConversationItems, setActiveConversationItems] = (0, import_react8.useState)([]);
  const [conversationResponse, setConversationResponse] = (0, import_react8.useState)([]);
  const [conversationsSettled, setConversationsSettled] = (0, import_react8.useState)(false);
  const [sortedHistory, setSortedHistory] = (0, import_react8.useState)([]);
  const [email, setEmail] = (0, import_react8.useState)("");
  const [modelOption, setModelOption] = (0, import_react8.useState)("");
  const [selectedLabel, setSelectedLabel] = (0, import_react8.useState)("Select answer generation");
  const [isTrainingMode, setIsTrainingMode] = (0, import_react8.useState)(false);
  const HEADER_TEXT = "Cisco AI Assistant";
  const MODEL_OPTIONS = [
    { value: "two", label: "Generate two answers" },
    { value: "one", label: "Generate one answers" }
  ];
  const handleThreadSelected = (0, import_react8.useCallback)(
    (id) => {
      setActiveConversationId(id);
      if (conversationResponse.length) {
        const items = conversationResponse.filter((item) => item.conversationId === id);
        setActiveConversationItems(items);
      }
      setConversationsSettled(true);
    },
    [conversationResponse]
  );
  const handleNewConversation = (0, import_react8.useCallback)(() => {
    const newId = generateUUID();
    setActiveConversationId(newId);
    setActiveConversationItems([]);
    const newHistoryItem = {
      id: newId,
      history: []
    };
    setSortedHistory((previous) => {
      if (previous.length) {
        const todayHistory = previous[previous.length - 1];
        todayHistory.conversationIds.push(newHistoryItem);
        return [...previous.slice(0, -1), todayHistory];
      }
      return [
        {
          date: "Today",
          conversationIds: [newHistoryItem]
        }
      ];
    });
    handleThreadSelected(newId);
  }, [handleThreadSelected]);
  const getHistoryItems = /* @__PURE__ */ __name(() => activeConversationItems.flatMap((historyItem) => [
    {
      id: historyItem.questionId,
      type: "question",
      query: historyItem.question
    },
    {
      id: generateUUID(),
      type: "answer",
      answer: [
        {
          id: generateUUID(),
          content: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            AIResponseStatic,
            {
              conversationId: historyItem.conversationId,
              questionId: historyItem.questionId,
              data: historyItem.answer,
              query: historyItem.question,
              email: historyItem.email,
              isCSaas,
              apiBasePath,
              isHelpCenter: false
            }
          )
        }
      ]
    }
  ]), "getHistoryItems");
  (0, import_react8.useEffect)(() => {
    if (isCSaas) {
      setEmail(cSaasEmail || "test@cisco.com");
    } else {
      const fetchEmail = /* @__PURE__ */ __name(async () => {
        const identityApiUrl = getIdentityUrl();
        const response = await fetch(identityApiUrl, {
          method: "get",
          headers: {
            Accept: "*/*"
          }
        });
        const data = response.json();
        if (data && data.user && data.user.email) {
          setEmail(data.user.email);
        }
      }, "fetchEmail");
      fetchEmail().catch(() => {
      });
    }
  }, [cSaasEmail, isCSaas]);
  (0, import_react8.useEffect)(() => {
    if (email && email !== "") {
      fetchAIConversations(isCSaas, cSaasPrefix, email, apiBasePath).then((response) => {
        if (response.length) {
          const sortedHistoryItems = sortConversations(response);
          const initSelectedId = response[response.length - 1].conversationId;
          const initItems = response.filter((item) => item.conversationId === initSelectedId);
          setConversationResponse(response);
          setSortedHistory(sortedHistoryItems);
          setActiveConversationItems(initItems);
          handleNewConversation();
        }
        setConversationsSettled(true);
      }).catch(() => {
        setConversationsSettled(true);
      });
    }
  }, [apiBasePath, cSaasPrefix, email, isCSaas]);
  const toggleTrainingMode = /* @__PURE__ */ __name((isTrainingModeEnabled) => {
    if (!isTrainingMode && !isTrainingModeEnabled && toggleFullScreen) {
      toggleFullScreen();
    }
    if (!isTrainingMode && isTrainingModeEnabled && setFullScreen) {
      setFullScreen(true);
    }
    setIsTrainingMode(isTrainingModeEnabled);
  }, "toggleTrainingMode");
  const handleToggleFullScreen = /* @__PURE__ */ __name(() => {
    if (toggleFullScreen) {
      toggleFullScreen();
    }
  }, "handleToggleFullScreen");
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
    Container,
    {
      className: `${isCSaas ? STYLES8.MAIN_CONTAINER_CSAAS : STYLES8.MAIN_CONTAINER}
    ${isFullScreen ? STYLES8.FULLSIZE_MAIN_CONTAINER : ""}`,
      children: [
        !isCSaas && /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("div", { className: STYLES8.HEADER, "data-testid": "ai-chat-window-header", children: [
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("h3", { children: HEADER_TEXT }),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("div", { className: STYLES8.HEADER_RIGHT_CONTAINER, children: [
            isAITrainingEnabled && /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(import_jsx_runtime14.Fragment, { children: [
              isTrainingMode && /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                import_uik21.Dropdown,
                {
                  kind: "SECONDARY",
                  label: selectedLabel,
                  onSelect: (selected) => {
                    setModelOption(MODEL_OPTIONS[selected[0]].value);
                    setSelectedLabel(MODEL_OPTIONS[selected[0]].label);
                  },
                  children: MODEL_OPTIONS.map(({ label }) => /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Dropdown.Option, { children: label }, label))
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(import_uik21.Toggle, { selected: isTrainingMode ? 0 : 1, children: [
                /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Button, { onClick: () => toggleTrainingMode(true), children: "Train AI" }),
                /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Button, { onClick: () => toggleTrainingMode(false), children: "Normal" })
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Button, { type: "TERTIARY", icon: "Action.Help" })
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Button, { type: "TERTIARY", icon: "Navigation.Fullscreen", onClick: handleToggleFullScreen }),
            /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Button, { type: "TERTIARY", icon: "Action.Disable", onClick: onCloseClick })
          ] })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
          "div",
          {
            className: `${STYLES8.MAIN_CONTENT}
            ${isFullScreen ? STYLES8.FULLSIZE_MAIN_CONTENT : ""}`,
            "data-testid": "ai-chat-window-main",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("div", { "data-testid": "ai-chat-window-left", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                AIConversationHistory,
                {
                  history: sortedHistory ?? [],
                  onSelect: handleThreadSelected,
                  onNewConversation: handleNewConversation,
                  currentThread: activeConversationId,
                  appName
                }
              ) }),
              /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("div", { className: STYLES8.RIGHT_PANEL, "data-testid": "ai-chat-window-right", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_uik21.Card, { className: STYLES8.RIGHT_PANEL_CARD, children: conversationsSettled && /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                AIAssistant,
                {
                  isAITrainingMode: isTrainingMode,
                  activeConversationId,
                  email,
                  historyItems: getHistoryItems(),
                  modelOption,
                  isCSaas,
                  isHelpCenter: false,
                  cSaasPrefix,
                  apiBasePath,
                  appName,
                  appId
                }
              ) }) })
            ]
          }
        )
      ]
    }
  );
}, "AIChatWindow");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AIAssistant,
  AIChatWindow
});
//# sourceMappingURL=fso-ui-shell-ai-assistant.js.map
